import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';

import Icon from '../../../../common/Icon';

const CheckoutCartProductRemove = ({
  onRemove,
  disabled,
  ariaLabel,
  isIconOnly = false,
}) => (
  <div
    className={
      isIconOnly
        ? 'CheckoutCartProductRow__remove-button CheckoutCartProductRow__remove-button--icon'
        : 'CheckoutCartProductRow__remove-button'
    }
  >
    <Button
      color="secondary"
      onClick={onRemove}
      aria-label={ariaLabel}
      disabled={disabled}
      size={isIconOnly ? 'sm' : undefined}
      className={
        isIconOnly ? 'CheckoutCartProductRow__remove-icon-btn' : undefined
      }
    >
      <Icon name={disabled ? 'circle-o-notch' : 'trash'} spin={disabled} />
    </Button>
  </div>
);

CheckoutCartProductRemove.propTypes = {
  onRemove: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  isIconOnly: PropTypes.bool,
};

export default CheckoutCartProductRemove;
